export default "__VITE_ASSET__CT$kBqB$__"